import { render, staticRenderFns } from "./RequestProposedBrigades.vue?vue&type=template&id=35519539&scoped=true&"
import script from "./RequestProposedBrigades.vue?vue&type=script&lang=js&"
export * from "./RequestProposedBrigades.vue?vue&type=script&lang=js&"
import style0 from "./RequestProposedBrigades.vue?vue&type=style&index=0&id=35519539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35519539",
  null
  
)

export default component.exports
import {QSplitter,QCard,QCardSection,QTable,QTr,QItemLabel,QTh,QTd,QCheckbox,QIcon,QTabs,QTab,QTabPanels,QTabPanel,QBanner,QAvatar} from 'quasar'
component.options.components = Object.assign({QSplitter,QCard,QCardSection,QTable,QTr,QItemLabel,QTh,QTd,QCheckbox,QIcon,QTabs,QTab,QTabPanels,QTabPanel,QBanner,QAvatar}, component.options.components || {})
